export default __webpack_public_path__ + "static/media/dialog-futuristic-primary.3a33bda3.svg";